export const translations = {
  'sv': {
    dropdownPlaceholder: 'Välj ett alternativ',
  },
  'en': {
    dropdownPlaceholder: 'Select an option',
  },
  'da': {
    dropdownPlaceholder: 'Vælg en mulighed',
  },
};